import "./App.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Main from "./layouts/Main";

import Statistics from "./components/Statistics/Statistics";
import Blog from "./components/Blog/Blog";
import Home from "./components/Home/Home";

import Topic from "./components/Topic/Topic";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import ReactQuiz from "./components/ReactQuiz/ReactQuiz";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main></Main>,
      errorElement: <ErrorPage></ErrorPage>,
      loader: () => {
        return fetch(`https://openapi.programming-hero.com/api/quiz`);
      },
      children: [
        {
          path: "/",
          element: <Home></Home>,
        },
        {
          path: "/topic",
          element: <Topic></Topic>,
        },

        {
          path: "statistics",
          element: <Statistics></Statistics>,
        },
        {
          path: "blog",
          element: <Blog></Blog>,
        },
        {
          path: "/quiz/:quizId",
          loader: async ({ params }) => {
            return fetch(
              `https://openapi.programming-hero.com/api/quiz/${params.quizId}`
            );
          },
          element: <ReactQuiz></ReactQuiz>,
        },
      ],
    },
  ]);
  return (
    <div className="">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
